import { ReactComponent as TimelinesSidebarSvg } from "../../assets/images/svgs/timelinesSidebar.svg";

const TimelinesSidebarIcon = ({ className = "", ...props }) => {
  return (
    <TimelinesSidebarSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default TimelinesSidebarIcon;
